import React, { useState } from "react";
/// React router dom
import { Switch, Route } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Dashboard
import Home from "./components/Dashboard/Home";

import Widget from "./pages/Widget";

import Login from "./pages/Login";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";
import UserManagement from "./pages/UserManagement";
import HotelOwner from "./pages/HotelOwner";
import UserDetails from "./pages/UserDetails";
import PropertyListing from "./pages/PropertyListing";
import HotelGroup from "./pages/HotelGroup";
import HotelAdmin from "./pages/HotelAdmin";
import Details from "./pages/Details";
import Category from "./pages/Category";

const Markup = () => {
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  let pagePath = path.split("-").includes("page");
  const [activeEvent, setActiveEvent] = useState(!path);

  const routes = [
    /// Dashboard
    { url: "", component: Home },
    { url: "dashboard", component: Home },

    /// User management

    { url: "user-management", component: UserManagement },
    { url: "hotel-owner", component: HotelOwner },
    { url: "hotel-group", component: HotelGroup },
    { url: "hotel-admin", component: HotelAdmin },
    { url: "property-listing", component: PropertyListing },
    { url: "user-details", component: UserDetails },

    { url: "widget-basic", component: Widget },

    { url: "page-login", component: Login },
    { url: "detail-page", component: Details },
    { url: "category", component: Category },

    
  ];

  return (
    <>
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}`}
      >
        {!pagePath && (
          <Nav
            onClick={() => setActiveEvent(!activeEvent)}
            activeEvent={activeEvent}
            onClick2={() => setActiveEvent(false)}
            onClick3={() => setActiveEvent(true)}
          />
        )}
        <div
          className={` ${!path && activeEvent ? "rightside-event" : ""} ${
            !pagePath ? "content-body" : ""
          }`}
        >
          <div
            className={`${!pagePath ? "container-fluid" : ""}`}
            style={{ minHeight: window.screen.height - 60 }}
          >
            <Switch>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                />
              ))}
            </Switch>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
      <ScrollToTop />
    </>
  );
};

export default Markup;
